exports = module.exports = require("./../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._2_PYBJ2PzRAajCZ_BTSdAL{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;position:fixed;top:0;height:100%;width:100%;-webkit-box-align:center;-ms-flex-align:center;align-items:center;z-index:2}", ""]);

// exports
exports.locals = {
	"saving": "_2_PYBJ2PzRAajCZ_BTSdAL"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules!./~/postcss-loader!./components/loading-overlay.css
 ** module id = 1021
 ** module chunks = 0
 **/